export enum Routes {
  INDEX = '',
  REGULAR_DONOR = 'pravidelny-darce',
  CHARITY_COLLECTIONS = 'DobrocinneSbirky',
  ACTIVE_COLLECTIONS = 'probihajici',
  FINISHED_COLLECTIONS = 'dokoncene',
  ASSIGN_UNUSED_GOOD_HABIT = 'uplatni-dobrozvyk-prispevky/potvrd',
  USE_GOOD_HABIT = 'uplatni-dobrozvyk/potvrd',
  DONT_BE_PASSIVE = 'nebud-pasivni',
  ABOUT_CHARITY_CROWDFUNDING = 'o-dobrocinnem-crowdfundingu',
  COMMERCIAL_PROJECTS = 'KomercniProjekty2',
  ACTIVE_PROJECTS = 'KomercniProjekty/probihajici',
  FINISHED_PROJECTS = 'KomercniProjekty/dokoncene',
  ABOUT_REWARD_CROWDFUNDING = 'o-odmenovem-crowdfundingu',
  HOW_DOES_IT_WORK = 'jak-donio-funguje',
  ABOUT_US = 'o-nas',
  SUGGESTION = 'navrh',
  LOGIN = 'login',
  TERMS_AND_CONDITIONS = 'pravidla',
  TERMS_AND_CONDITIONS_2025_07_31 = 'zasady-platne-od-31-cervence-2025',
  PRIVACY_POLICY = 'zasady',
  PRIVACY_POLICY_2025_07_31 = 'podminky-platne-od-31-cervence-2025',
  DONATION = 'prispevek',
  DONATION_DETAIL = 'prispevek/detail',
  CHALLENGE = 'Dobrovyzva',
  NEW_CHALLENGE = 'moje-donio/vytvorit-dobrovyzvu',
  MY_DONATIONS = 'moje-donio/vsechny-prispevky',
  HOW_TO_CREATE_CHARITY_COLLECTION = 'rady/dobrocinne-sbirky',
  FLOODINGS_2024 = 'povodne2024',
  HELP_UKRAINE = 'pomocukrajine',
  GOOD_HABIT = 'mujdobrozvyk',
  LONG_TERM_COLLECTIONS = 'dlouhodobe-sbirky',
  HOW_TO_CREATE_COMMERCIAL_PROJECT = 'rady/komercni-projekty',
  NGOS = 'neziskove-organizace',
  COMPANIES = 'pro-firmy',
  CAREER = 'kariera',
  IN_MEDIA = 'napsali-o-nas',
  ANNUAL_REPORT_2023 = 'rok-2023',
  FOR_MEDIA = 'pro-media',
  CONTACT = 'kontakt',
  FAQS = 'caste-dotazy',
  BLOG = 'blog',
  PLATFORM_BENCHMARK = 'srovnani-platforem',
  OPEN_ACCOUNT = 'transparentni-ucet',
  DONIO_CODE = 'kodex',
  COOKIES = 'cookies',
  ADMIN = 'admin',
  PROJECT_ADMIN = 'admin/project',
  EDIT_PROFILE = 'profil/zmena-udaju',
  CHANGE_PASSWORD = 'profil/zmena-hesla',
  MY_DONIO_REGULAR_DONOR = 'moje-donio/pravidelny-darce',
  MY_CHALLENGES = 'moje-donio/moje-dobrovyzvy',
  MY_STORIES = 'moje-donio/moje-pribehy',
  // TODO: this is dynamic page and it will be improved in the future
  TOGETHER_FOR_UKRAINE = 'spolocne-pre-ukrajinu',
  LOGOUT = 'logout',
  ABOUT_ONLINE_FUNDRAISING = 'online-fundraising',
  START_PROJECT = 'nastartuj-projekt',
  START_PROJECT_ACTIVE_CAMPAIGNS = 'nastartuj-projekt/prebiehajuce',
  START_PROJECT_FINISHED_CAMPAIGNS = 'nastartuj-projekt/dokoncene',
  INDIVIDUALS = 'jednotlivci',
  PARTNERS = 'partneri',
  AMBASSADORS = 'ambasadori',
  MEDIA = 'pre-media',
  MY_DONIO = 'moje-donio',
  SUPPORT_DONIO_WITH_TWO_PERCENTS = '2-percenta',
  WROTE_ABOUT_US = 'napisali-o-nas',
  YEAR_BOOK_2024 = 'rok-2024',
  YEAR_BOOKS = 'vyrocne-spravy',
  HOW_IT_WORKS = 'ako-donio-funguje',
  FUNDRAISING = 'online-fundraising',
  CROWDFUNDING = 'odmenovy-crowdfunding',
  MOJADOBROKARTA = 'mojadobrokarta',
  TRANSPARENT_ACCOUNT = 'transparentny-ucet',
  XMAS = 'DarujteDobrost',
  PAGE_TWO_PERCENT = '2-percenta',
  NON_PROFIT = 'neziskove-organizacie',
  FOR_COMPANIES = 'pre-firmy',
  AMBASSADOR = 'ambasadori',
  PRESS = 'pre-media',
  BLOG_HOMEPAGE = 'blog',
  FAQ = 'caste-otazky',
  CODE_OF_ETHICS = 'kodex',
}

export enum UtmSource {
  COPYLINK = 'copylink',
  INSTAGRAM = 'instagram',
  FACEBOOK = 'facebook',
  TWITTER = 'twitter',
  LINKEDIN = 'linkedin',
  EMAIL = 'email',
  WHATSAPP = 'whatsapp',
  OTHER = 'other',
}

export enum UtmMedium {
  SOCIAL_SHARE = 'socialshare',
  SHARE_BUTTON = 'share_button',
}

export enum UtmCampaign {
  SHARE_BUTTON = 'share_button',
}

export enum MixpanelEventSource {
  NextJs = 'Next.js',
}

export enum Country {
  CZECH_REPUBLIC = 'CZ',
  SLOVAKIA = 'SK',
  AFGHANISTAN = 'AF',
  ALAND_ISLANDS = 'AX',
  ALBANIA = 'AL',
  ALGERIA = 'DZ',
  AMERICAN_SAMOA = 'AS',
  ANDORRA = 'AD',
  ANGOLA = 'AO',
  ANGUILLA = 'AI',
  ANTARCTICA = 'AQ',
  ANTIGUA_AND_BARBUDA = 'AG',
  ARGENTINA = 'AR',
  ARMENIA = 'AM',
  ARUBA = 'AW',
  AUSTRALIA = 'AU',
  AUSTRIA = 'AT',
  AZERBAIJAN = 'AZ',
  BAHAMAS = 'BS',
  BAHRAIN = 'BH',
  BANGLADESH = 'BD',
  BARBADOS = 'BB',
  BELARUS = 'BY',
  BELGIUM = 'BE',
  BELIZE = 'BZ',
  BENIN = 'BJ',
  BERMUDA = 'BM',
  BHUTAN = 'BT',
  BOLIVIA = 'BO',
  BONAIRE_SINT_EUSTATIUS_AND_SABA = 'BQ',
  BOSNIA_AND_HERZEGOVINA = 'BA',
  BOTSWANA = 'BW',
  BOUVET_ISLAND = 'BV',
  BRAZIL = 'BR',
  BRITISH_INDIAN_OCEAN_TERRITORY = 'IO',
  BRUNEI_DARUSSALAM = 'BN',
  BULGARIA = 'BG',
  BURKINA_FASO = 'BF',
  BURUNDI = 'BI',
  CAMBODIA = 'KH',
  CAMEROON = 'CM',
  CANADA = 'CA',
  CAPE_VERDE = 'CV',
  CAYMAN_ISLANDS = 'KY',
  CENTRAL_AFRICAN_REPUBLIC = 'CF',
  CHAD = 'TD',
  CHILE = 'CL',
  CHINA = 'CN',
  CHRISTMAS_ISLAND = 'CX',
  COCOS_KEELING_ISLANDS = 'CC',
  COLOMBIA = 'CO',
  COMOROS = 'KM',
  CONGO = 'CG',
  THE_DEMOCRATIC_REPUBLIC_OF_THE_CONGO = 'CD',
  COOK_ISLANDS = 'CK',
  COSTA_RICA = 'CR',
  COTE_DIVOIRE = 'CI',
  CROATIA = 'HR',
  CUBA = 'CU',
  CURACAO = 'CW',
  CYPRUS = 'CY',
  DENMARK = 'DK',
  DJIBOUTI = 'DJ',
  DOMINICA = 'DM',
  DOMINICAN_REPUBLIC = 'DO',
  ECUADOR = 'EC',
  EGYPT = 'EG',
  EL_SALVADOR = 'SV',
  EQUATORIAL_GUINEA = 'GQ',
  ERITREA = 'ER',
  ESTONIA = 'EE',
  ETHIOPIA = 'ET',
  FALKLAND_ISLANDS_MALVINAS = 'FK',
  FAROE_ISLANDS = 'FO',
  FIJI = 'FJ',
  FINLAND = 'FI',
  FRANCE = 'FR',
  FRENCH_GUIANA = 'GF',
  FRENCH_POLYNESIA = 'PF',
  FRENCH_SOUTHERN_TERRITORIES = 'TF',
  GABON = 'GA',
  GAMBIA = 'GM',
  GEORGIA = 'GE',
  GERMANY = 'DE',
  GHANA = 'GH',
  GIBRALTAR = 'GI',
  GREECE = 'GR',
  GREENLAND = 'GL',
  GRENADA = 'GD',
  GUADELOUPE = 'GP',
  GUAM = 'GU',
  GUATEMALA = 'GT',
  GUERNSEY = 'GG',
  GUINEA = 'GN',
  GUINEA_BISSAU = 'GW',
  GUYANA = 'GY',
  HAITI = 'HT',
  HEARD_ISLAND_AND_MCDONALD_ISLANDS = 'HM',
  HOLY_SEE_VATICAN_CITY_STATE = 'VA',
  HONDURAS = 'HN',
  HONG_KONG = 'HK',
  HUNGARY = 'HU',
  ICELAND = 'IS',
  INDIA = 'IN',
  INDONESIA = 'ID',
  IRAN = 'IR',
  IRAQ = 'IQ',
  IRELAND = 'IE',
  ISLE_OF_MAN = 'IM',
  ISRAEL = 'IL',
  ITALY = 'IT',
  JAMAICA = 'JM',
  JAPAN = 'JP',
  JERSEY = 'JE',
  JORDAN = 'JO',
  KAZAKHSTAN = 'KZ',
  KENYA = 'KE',
  KIRIBATI = 'KI',
  DEMOCRATIC_PEOPLES_REPUBLIC_OF_KOREA = 'KP',
  REPUBLIC_OF_KOREA = 'KR',
  KUWAIT = 'KW',
  KYRGYZSTAN = 'KG',
  LAO_PEOPLES_DEMOCRATIC_REPUBLIC = 'LA',
  LATVIA = 'LV',
  LEBANON = 'LB',
  LESOTHO = 'LS',
  LIBERIA = 'LR',
  LIBYA = 'LY',
  LIECHTENSTEIN = 'LI',
  LITHUANIA = 'LT',
  LUXEMBOURG = 'LU',
  MACAO = 'MO',
  MACEDONIA = 'MK',
  MADAGASCAR = 'MG',
  MALAWI = 'MW',
  MALAYSIA = 'MY',
  MALDIVES = 'MV',
  MALI = 'ML',
  MALTA = 'MT',
  MARSHALL_ISLANDS = 'MH',
  MARTINIQUE = 'MQ',
  MAURITANIA = 'MR',
  MAURITIUS = 'MU',
  MAYOTTE = 'YT',
  MEXICO = 'MX',
  MICRONESIA = 'FM',
  MOLDOVA = 'MD',
  MONACO = 'MC',
  MONGOLIA = 'MN',
  MONTENEGRO = 'ME',
  MONTSERRAT = 'MS',
  MOROCCO = 'MA',
  MOZAMBIQUE = 'MZ',
  MYANMAR = 'MM',
  NAMIBIA = 'NA',
  NAURU = 'NR',
  NEPAL = 'NP',
  NETHERLANDS = 'NL',
  NEW_CALEDONIA = 'NC',
  NEW_ZEALAND = 'NZ',
  NICARAGUA = 'NI',
  NIGER = 'NE',
  NIGERIA = 'NG',
  NIUE = 'NU',
  NORFOLK_ISLAND = 'NF',
  NORTHERN_MARIANA_ISLANDS = 'MP',
  NORWAY = 'NO',
  OMAN = 'OM',
  PAKISTAN = 'PK',
  PALAU = 'PW',
  PALESTINE = 'PS',
  PANAMA = 'PA',
  PAPUA_NEW_GUINEA = 'PG',
  PARAGUAY = 'PY',
  PERU = 'PE',
  PHILIPPINES = 'PH',
  PITCAIRN = 'PN',
  POLAND = 'PL',
  PORTUGAL = 'PT',
  PUERTO_RICO = 'PR',
  QATAR = 'QA',
  REUNION = 'RE',
  ROMANIA = 'RO',
  RUSSIAN_FEDERATION = 'RU',
  RWANDA = 'RW',
  SAINT_BARTHELEMY = 'BL',
  SAINT_HELENA = 'SH',
  SAINT_KITTS_AND_NEVIS = 'KN',
  SAINT_LUCIA = 'LC',
  SAINT_MARTIN = 'MF',
  SAINT_PIERRE_AND_MIQUELON = 'PM',
  SAINT_VINCENT_AND_THE_GRENADINES = 'VC',
  SAMOA = 'WS',
  SAN_MARINO = 'SM',
  SAO_TOME_AND_PRINCIPE = 'ST',
  SAUDI_ARABIA = 'SA',
  SENEGAL = 'SN',
  SERBIA = 'RS',
  SEYCHELLES = 'SC',
  SIERRA_LEONE = 'SL',
  SINGAPORE = 'SG',
  SINT_MAARTEN = 'SX',
  SLOVENIA = 'SI',
  SOLOMON_ISLANDS = 'SB',
  SOMALIA = 'SO',
  SOUTH_AFRICA = 'ZA',
  SOUTH_GEORGIA_AND_THE_SOUTH_SANDWICH_ISLANDS = 'GS',
  SOUTH_SUDAN = 'SS',
  SPAIN = 'ES',
  SRI_LANKA = 'LK',
  SUDAN = 'SD',
  SURINAME = 'SR',
  SVALBARD_AND_JAN_MAYEN = 'SJ',
  SWAZILAND = 'SZ',
  SWEDEN = 'SE',
  SWITZERLAND = 'CH',
  SYRIAN_ARAB_REPUBLIC = 'SY',
  TAIWAN = 'TW',
  TAJIKISTAN = 'TJ',
  TANZANIA = 'TZ',
  THAILAND = 'TH',
  TIMOR_LESTE = 'TL',
  TOGO = 'TG',
  TOKELAU = 'TK',
  TONGA = 'TO',
  TRINIDAD_AND_TOBAGO = 'TT',
  TUNISIA = 'TN',
  TURKEY = 'TR',
  TURKMENISTAN = 'TM',
  TURKS_AND_CAICOS_ISLANDS = 'TC',
  TUVALU = 'TV',
  UGANDA = 'UG',
  UKRAINE = 'UA',
  UNITED_ARAB_EMIRATES = 'AE',
  UNITED_KINGDOM = 'GB',
  UNITED_STATES = 'US',
  UNITED_STATES_MINOR_OUTLYING_ISLANDS = 'UM',
  URUGUAY = 'UY',
  UZBEKISTAN = 'UZ',
  VANUATU = 'VU',
  VENEZUELA = 'VE',
  VIET_NAM = 'VN',
  VIRGIN_ISLANDS_BRITISH = 'VG',
  VIRGIN_ISLANDS_US = 'VI',
  WALLIS_AND_FUTUNA = 'WF',
  WESTERN_SAHARA = 'EH',
  YEMEN = 'YE',
  ZAMBIA = 'ZM',
  ZIMBABWE = 'ZW',
}

export enum DonationFormType {
  SINGLE_AUTHENTICATED_USER = 'single_authenticated_user',
  SINGLE_UNAUTHENTICATED_USER = 'single_unauthenticated_user',
  LONG_TERM_AUTHENTICATED_USER = 'long_term_authenticated_user',
  LONG_TERM_UNAUTHENTICATED_USER = 'long_term_unauthenticated_user',
  GOOD_HABIT_AUTHENTICATED_USER = 'good_habit_authenticated_user',
  GOOD_HABIT_UNAUTHENTICATED_USER = 'good_habit_unauthenticated_user',
  COMMERCIAL_PROJECT = 'commercial_project',
}

export enum PromoSource {
  FOOTER = 'footer',
  SUBSCRIPTION_BAR = 'subscription_bar',
}

export enum BusinessEnvironment {
  LOCAL = 'local',
  DEV = 'dev',
  PROD = 'prod',
}

export enum PaymentMethod {
  ApplePay = 'applepay',
  Card = 'card',
  WireTransfer = 'wire-transfer',
  QrCode = 'qr-code',
}
export enum Language {
  CZ = 'cs',
  EN = 'en',
  SK = 'sk',
}
